import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Clock, Settings as SettingsIcon } from 'lucide-react';

const tabs = [
  { to: '/', icon: Home, label: 'Accueil', testid: 'nav-accueil' },
  { to: '/history', icon: Clock, label: 'Historique', testid: 'nav-historique' },
  { to: '/settings', icon: SettingsIcon, label: 'Réglages', testid: 'nav-reglages' },
];

export default function MobileLayout({ children, hideNav = false }) {
  const location = useLocation();
  return (
    <div className="mobile-shell">
      {children}
      {!hideNav && (
        <nav
          data-testid="bottom-nav"
          className="shell-dock bg-white border-t border-slate-200 flex justify-around items-center h-16"
        >
          {tabs.map((t) => {
            const active =
              t.to === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(t.to);
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                data-testid={t.testid}
                className="flex flex-col items-center gap-1 text-xs font-medium transition-colors"
                style={{ color: active ? '#2563EB' : '#64748B' }}
              >
                <Icon size={22} strokeWidth={active ? 2.4 : 2} />
                <span>{t.label}</span>
              </NavLink>
            );
          })}
        </nav>
      )}
    </div>
  );
}
